module.exports = __webpack_public_path__ + "img/tjgw.d8adac72.jpg";